import React, { useEffect, useRef, useState } from 'react';
import { ChevronDownIcon } from 'lucide-react';
type AccordionProps = {
  id: string;
  header: React.ReactNode;
  children: React.ReactNode;
  defaultOpen?: boolean;
  className?: string;
  openClassName?: string;
};
export function Accordion({
  id,
  header,
  children,
  defaultOpen = false,
  className = '',
  openClassName = ''
}: AccordionProps) {
  const [open, setOpen] = useState(defaultOpen);
  const panelRef = useRef<HTMLDivElement | null>(null);
  const [maxHeight, setMaxHeight] = useState(defaultOpen ? 'none' : '0px');
  useEffect(() => {
    const el = panelRef.current;
    if (!el) return;
    setMaxHeight(open ? `${el.scrollHeight}px` : '0px');
  }, [open, children]);
  return <div className={`overflow-hidden rounded-2xl border transition-colors duration-200 ease-out ${open ? `border-coral/35 ${openClassName}` : 'border-line'} ${className}`} data-id="element-9" data-mp="2s3k03olixc1e">
      <button type="button" aria-expanded={open} aria-controls={`${id}-panel`} id={`${id}-header`} onClick={() => setOpen(v => !v)} className="flex min-h-[64px] w-full items-center gap-4 px-5 py-4 text-left sm:px-6" data-id="element-10" data-mp="xpsv52e53gca">
        <span className="flex-1" data-id="element-11" data-mp="3l3yoqxcp1gh0">{header}</span>
        <ChevronDownIcon aria-hidden="true" className={`h-5 w-5 shrink-0 text-coral transition-transform duration-200 ease-out ${open ? 'rotate-180' : ''}`} data-id="element-12" data-mp="3q29zrbeq5x0t" />
      </button>

      <div id={`${id}-panel`} role="region" aria-labelledby={`${id}-header`} ref={panelRef} className="accordion-panel" style={{
      maxHeight
    }} data-id="element-13" data-mp="3uv32jtqmuva9">
        <div className="px-5 pb-6 pt-0 sm:px-6" data-id="element-14" data-mp="7niuptmyws0r">{children}</div>
      </div>
    </div>;
}